import React from 'react';
import { colors } from 'seedling/constants';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const grippyIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox={`0 0 20 20`}
    className={props.className}
  >
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M6 1h2.8v3.033H6V1zm5 0h2.8v3.033H11V1zM6 5.983h2.8v3.034H6V5.983zM11 6h2.8v3.033H11V6zm-5 5h2.8v3.033H6V11zm0 4.983h2.8v3.034H6v-3.034zM11 11h2.8v3.033H11V11zm0 5h2.8v3.033H11V16z"
    />
  </svg>
);

const GrippyIcon = styled(grippyIcon)`
  cursor: move;
  vertical-align: ${props => props.verticalAlign};
`;

GrippyIcon.displayName = 'GrippyIcon';

GrippyIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  verticalAlign: PropTypes.string,
  color: PropTypes.string,
};

GrippyIcon.defaultProps = {
  width: 20,
  height: 20,
  verticalAlign: 'baseline',
  color: colors.lightGrey,
};

export default GrippyIcon;
